/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { Injectable, Injector } from '@angular/core';
// import { Analytics } from '@angular/fire/analytics';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
// import { environment } from 'src/environments/environment';

import { OSKCookieConsent } from '../models/cookie_consent.model';
import { OSKCookieConsentBannerComponent } from '../cookie_consent_banner.component';

@Injectable({
  providedIn: 'root'
})
export class OSKCookieConsentService {
  // private _analytics: Analytics = inject(Analytics);
  private _isSet: boolean = false;
  private _hasChanged: boolean = false;
  private _consentToStricklyNecessaryCookies: boolean = true;
  private _consentToPerformanceCookies: boolean = false;
  private _consentToTargetingCookies: boolean = false;

  constructor(
    private _cookieService: CookieService,
    private _modalService: NgbModal,
    private _injector: Injector
  ) {
    this._load();
    this._apply();
    if (!this._isSet) {
      this.showBanner();
    }
  }

  get consentToStricklyNecessary(): boolean {
    return this._consentToStricklyNecessaryCookies;
  }

  get consentToPerformanceCookie(): boolean {
    return this._consentToPerformanceCookies;
  }

  get consentToTargetingCookies(): boolean {
    return this._consentToTargetingCookies;
  }

  showBanner(): void {
    const cookieConsent: OSKCookieConsent = {
      consentToStricklyNecessaryCookies: this._consentToStricklyNecessaryCookies,
      consentToPerformanceCookies: this._consentToPerformanceCookies,
      consentToTargetingCookies: this._consentToTargetingCookies
    };

    this._modalService
      .open(OSKCookieConsentBannerComponent, {
        backdrop: 'static',
        animation: true,
        modalDialogClass: 'modal-dialog-bottom-left',
        size: 'lg',
        injector: Injector.create({
          providers: [
            {
              provide: OSKCookieConsent,
              useValue: cookieConsent
            }
          ],
          parent: this._injector
        })
      })
      .result.then((result) => {
        const cookieConsent = result as OSKCookieConsent;
        this._update(cookieConsent);
      });
  }

  private _update(cookieConsent: OSKCookieConsent): void {
    this._hasChanged =
      this._consentToStricklyNecessaryCookies !== cookieConsent.consentToStricklyNecessaryCookies ||
      this._consentToPerformanceCookies !== cookieConsent.consentToPerformanceCookies ||
      this._consentToTargetingCookies !== cookieConsent.consentToTargetingCookies;
    this._consentToStricklyNecessaryCookies =
      cookieConsent.consentToStricklyNecessaryCookies ?? true;
    this._consentToPerformanceCookies = cookieConsent.consentToPerformanceCookies ?? false;
    this._consentToTargetingCookies = cookieConsent.consentToTargetingCookies ?? false;
    this._cookieService.set('cookie_consent', JSON.stringify(cookieConsent), 30);
    this._load();
    this._apply();
  }

  private _load(): void {
    if (this._cookieService.check('cookie_consent')) {
      const cookieConsent =
        (JSON.parse(this._cookieService.get('cookie_consent')) as OSKCookieConsent) ?? {};
      this._consentToStricklyNecessaryCookies =
        cookieConsent.consentToStricklyNecessaryCookies ?? true;
      this._consentToPerformanceCookies = cookieConsent.consentToPerformanceCookies ?? false;
      this._consentToTargetingCookies = cookieConsent.consentToTargetingCookies ?? false;
      this._isSet =
        cookieConsent.consentToStricklyNecessaryCookies !== undefined &&
        cookieConsent.consentToPerformanceCookies !== undefined &&
        cookieConsent.consentToTargetingCookies !== undefined;
    } else {
      this._isSet = false;
    }
  }

  private _apply(): void {
    // this._analytics.app.automaticDataCollectionEnabled = environment.useEmulator ? false : this._consentToPerformanceCookies;
    // if (!this._consentToPerformanceCookies) {
    //     this._cookieService.delete('_ga');
    //     this._cookieService.delete(`_ga_${environment.firebaseConfig.measurementId.split('-')[1]}`);
    // }
    if (this._hasChanged) {
      window.location.reload();
    }
  }
}
